import { useFormSelectedSkillsFrameworks } from "PFApp/activities/activity_form/hooks/use_form_selected_skills_frameworks";
import { Inline } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";
import { Typography } from "PFComponents/typography";

import css from "./skills_frameworks_list.module.scss";

export const SkillsFrameworksList = () => {
  const { selectedSkillsFrameworks } = useFormSelectedSkillsFrameworks();

  return (
    <Inline wrap="wrap">
      {selectedSkillsFrameworks.map(({ id, name }, index) => (
        <Inline key={id} className={css.frameworkName}>
          <Typography variant="labelBold" title={name} textOverflow="clip">
            {name}
          </Typography>
          {index < selectedSkillsFrameworks.length - 1 && <Divider type="vertical" />}
        </Inline>
      ))}
    </Inline>
  );
};
